(() => {
  const HEADER_OFFSET = 90;
  const TRIGGER_SELECTOR = "#reviewsJump";
  const REVIEW_SELECTORS = [
    "#judgeme_product_reviews",
    "#judgeme_product_reviews_widget",
    ".jdgm-widget",
    ".jdgm-rev-widg",
    ".jdgm-review-widget",
    "#shopify-product-reviews",
    ".spr-reviews",
    "#stamped-main-widget",
    "#looxReviews",
    "#loox-reviews",
    "#yotpo-main-widget",
    ".yotpo-main-widget",
    "#customer-reviews",
    ".product-reviews"
  ];

  function findReviewWidgetTop() {
    for (let i = 0; i < REVIEW_SELECTORS.length; i += 1) {
      const el = document.querySelector(REVIEW_SELECTORS[i]);
      if (el) return el;
    }
    return null;
  }

  function scrollToReviewsTop() {
    const target = findReviewWidgetTop();
    if (!target) return false;

    const top = target.getBoundingClientRect().top + window.pageYOffset - HEADER_OFFSET;
    window.scrollTo({ top: Math.max(0, top), behavior: "smooth" });
    return true;
  }

  function onTrustedReviewsClick(event) {
    const trigger = event.target.closest(TRIGGER_SELECTOR);
    if (!trigger) return;

    event.preventDefault();
    event.stopPropagation();

    if (!scrollToReviewsTop()) {
      // Judge.me can mount late on some templates.
      setTimeout(scrollToReviewsTop, 250);
      setTimeout(scrollToReviewsTop, 700);
      setTimeout(scrollToReviewsTop, 1300);
    }
  }

  // Capture phase prevents legacy inline handlers from applying bottom-page fallback.
  document.addEventListener("click", onTrustedReviewsClick, true);
})();
